<template>
  <section class="row responsivo">
    <div v-if="primeiro" style="background-color: #00c0ef" class="col-6 padrao">
      <div class="valor-principal">
        <span v-if="sifraoPrimeiro == true">R$</span>

        <span>{{ primeiro }} </span>
        <q-tooltip> R$ {{ primeiro }} </q-tooltip>
      </div>
      <div class="text-subtitle1 custom-caption">{{ subPrimeiro }}</div>
    </div>
    <div v-if="segundo" style="background-color: #58c16d" class="col-6 padrao">
      <div class="valor-principal">
        <span v-if="sifraoSegundo == true">R$</span> {{ segundo }}
      </div>
      <div class="text-subtitle1 custom-caption">{{ subSegundo }}</div>
      <q-tooltip> {{ segundo }} </q-tooltip>
    </div>
    <div v-if="terceiro" style="background-color: #f39c12" class="col-6 padrao">
      <div class="valor-principal">
        <span v-if="sifraoTerceiro == true">R$</span> {{ terceiro }}
        <q-tooltip> {{ terceiro }} </q-tooltip>
      </div>
      <div class="text-subtitle1 custom-caption">{{ subTerceiro }}</div>
    </div>
    <div v-if="quarto" style="background-color: #dd4b39" class="col-6 padrao">
      <div class="valor-principal">
        <span v-if="sifraoQuarto == true">R$</span>
        {{ quarto }}
      </div>
      <div class="text-subtitle1 custom-caption">{{ subQuarto }}</div>
      <q-tooltip> R$ {{ quarto }} </q-tooltip>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    primeiro: { type: String },
    sifraoPrimeiro: { type: Boolean },
    subPrimeiro: { type: String },
    segundo: { type: String },
    sifraoSegundo: { type: Boolean },
    subSegundo: { type: String },
    terceiro: { type: String },
    sifraoTerceiro: { type: Boolean },
    subTerceiro: { type: String },
    quarto: { type: String },
    sifraoQuarto: { type: Boolean },
    subQuarto: { type: String },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.padrao {
  width: 24%;
  margin-left: 8px;
  height: 129px;
  border-radius: 8px;
  padding: 7px;
  color: white;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 1171px) {
  .responsivo {
    flex-direction: column;
  }

  .padrao {
    margin-top: 7px;
    width: 100%;
    align-items: center;
  }
}

.padrao .valor-principal {
  font-size: 38px;
}

.custom-caption {
  text-align: center;
  padding: 12px;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
